import { Controller } from "stimulus"

export default class extends Controller {
    saveImage(){
        const form = document.getElementById("ad-image-form")
        form.setAttribute("action", "/create_ad_image")
        form.submit()
    }
}